import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PaymentService from "../services/payment.service";
import AuthService from "../services/auth.service";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        // Give webhook time to process (optional, webhook should handle activation)
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        const status = await PaymentService.getSubscriptionStatus();
        
        if (status.subscriptionActive) {
          setVerified(true);
        }
        
        setChecking(false);
      } catch (error) {
        console.error("Error verifying payment:", error);
        setChecking(false);
      }
    };

    verifyPayment();
  }, []);

  const handleContinue = () => {
    // Log out user to clear old subscription status
    AuthService.logout();
    // Redirect to login page - user needs to log in again to get updated subscription status
    window.location.href = "/";
  };

  return (
    <div id="login-container">
      <div className="container">
        <div className="col-md-12">
          <div id="login-content">
            <div className="card card-container auth-status-card">
              {checking ? (
                <>
                  <div className="auth-status-icon">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div id="content-title">{t('Processing Payment...')}</div>
                  <p className="auth-lead">{t('Please wait while we confirm your payment...')}</p>
                </>
              ) : (
                <>
                  <div className={`auth-status-icon ${verified ? 'success' : 'pending'}`}>
                    <i className={verified ? 'icon-check' : 'icon-clock'} />
                  </div>
                  <div id="content-title">
                    {verified ? t('Payment Successful!') : t('Payment Received')}
                  </div>
                  
                  <div className="auth-lead">
                    {verified ? (
                      <>
                        <p>
                          {t('Thank you for subscribing to Risqui! Your subscription has been activated.')}
                        </p>
                        <p>
                          {t('You now have full access to all features for one year.')}
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          {t('Your payment has been received and is being processed.')}
                        </p>
                        <p>
                          {t('Your subscription will be activated shortly. You will receive a confirmation email.')}
                        </p>
                      </>
                    )}
                  </div>

                  <button 
                    className="btn btn-outline-primary btn-block login-submit"
                    onClick={handleContinue}
                  >
                    {t('Login to Continue')}
                  </button>

                  {!verified && (
                    <div className="auth-footnote">
                      <p>
                        {t('If you experience any issues, please contact us at')}{' '}
                        <a href="mailto:info@risqui.nl">info@risqui.nl</a>
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
